/**
 * Consentik (Aug 2026+) renders the banner inside #cst-shadow-host shadowRoot.
 * Theme stylesheets cannot pierce shadow DOM — inject BBE bar styles after mount.
 */
;(function () {
  var STYLE_ID = 'bbe-cookie-banner-coexist'
  var CSS =
    '#cst-root{--cst-element-align:flex-start!important}' +
    '#cst-root #cookies-wrapper,' +
    '#cst-root #cookies-wrapper.cst-position-full-bottom{' +
    'z-index:10060!important;' +
    'background:#fff!important;' +
    'border-top:1px solid #e8e8e8!important;' +
    'box-shadow:0 -4px 24px rgba(0,0,0,.06)!important;' +
    'padding:6px 16px!important;' +
    'padding-bottom:calc(6px + env(safe-area-inset-bottom,0px))!important;' +
    'box-sizing:border-box!important;' +
    'align-items:stretch!important;' +
    'justify-content:flex-start!important;' +
    'overflow:visible!important;' +
    'width:100%!important;' +
    'max-width:100vw!important;' +
    'height:auto!important;' +
    'min-height:0!important;' +
    'max-height:none!important;' +
    'top:auto!important;' +
    'bottom:0!important;' +
    'left:0!important;transform:none!important;' +
    'flex:none!important' +
    '}' +
    '#cst-root #ot-cookie-banner{' +
    'width:100%!important;' +
    'height:auto!important;' +
    'min-height:0!important;' +
    'max-height:none!important;' +
    'justify-content:flex-start!important;' +
    'flex:none!important;' +
    'overflow:visible!important' +
    '}' +
    '#cst-root .cb__inner{' +
    'display:grid!important;' +
    'grid-template-columns:minmax(0,1fr) auto!important;' +
    'grid-template-rows:auto auto!important;' +
    'grid-template-areas:"msg actions" "policy actions"!important;' +
    'column-gap:20px!important;' +
    'row-gap:2px!important;' +
    'align-items:center!important;' +
    'justify-content:flex-start!important;' +
    'height:auto!important;' +
    'min-height:0!important;' +
    'padding:0!important;' +
    'text-align:left!important' +
    '}' +
    '#cst-root .cb__text-block{' +
    'flex:1 1 220px!important;' +
    'min-width:0!important;' +
    'align-items:flex-start!important;' +
    'text-align:left!important;' +
    'gap:0!important;' +
    'display:block!important;' +
    'grid-area:msg!important' +
    '}' +
    '#cst-root .cst-banner-header,#cst-root #cookies-icon,#cst-root .cookies-icon,#cst-root .cst-collapse-inner-icon{display:none!important}' +
    '#cst-root .cookie-banner__message{' +
    'margin:0!important;' +
    'line-height:1.3!important;' +
    'font-size:14px!important;' +
    'text-align:left!important;' +
    'display:block!important;' +
    'color:#1a1a1a!important;' +
    'font-family:var(--font-body-family,Avenir Next,Avenir,Helvetica Neue,Helvetica,Arial,sans-serif)!important' +
    '}' +
    '#cst-root .cb__after-text{display:block!important;margin:0!important;grid-area:policy!important}' +
    '#cst-root .cookie-banner__policy-links{display:block!important}' +
    '#cst-root .cookie-banner__link{' +
    'font-size:14px!important;' +
    'color:#1a1a1a!important;' +
    'text-decoration:underline!important' +
    '}' +
    '#cst-root .cookie-banner__actions{' +
    'flex:0 0 auto!important;' +
    'display:flex!important;' +
    'flex-direction:row!important;' +
    'flex-wrap:wrap!important;' +
    'gap:12px 16px!important;' +
    'align-items:center!important;' +
    'justify-content:flex-end!important;' +
    'width:auto!important;margin:0!important;' +
    'grid-area:actions!important;' +
    'align-self:center!important' +
    '}' +
    '#cst-root .cookie-banner__actions-right{display:contents!important}' +
    '#cst-root button.ot-cookie{' +
    'min-height:32px!important;' +
    'padding:4px 14px!important;' +
    'line-height:1.2!important;' +
    'font-size:14px!important;' +
    'border-radius:4px!important;' +
    'width:auto!important;' +
    'min-width:0!important;' +
    'font-family:var(--font-body-family,Avenir Next,Avenir,Helvetica Neue,Helvetica,Arial,sans-serif)!important;' +
    'cursor:pointer!important;' +
    'box-shadow:none!important' +
    '}' +
    '#cst-root #cookies-submit{' +
    'background:#000!important;' +
    'color:#fff!important;' +
    'border:1px solid #000!important;' +
    'font-weight:700!important;' +
    'min-width:110px!important' +
    '}' +
    '#cst-root #cookies-preferences,#cst-root #cookies-dismiss{' +
    'background:transparent!important;' +
    'color:#1a1a1a!important;' +
    'border:none!important;' +
    'font-weight:700!important;' +
    'padding:4px 4px!important' +
    '}' +
    '#cst-root #cookies-preferences:hover,#cst-root #cookies-dismiss:hover{text-decoration:underline!important}' +
    '@media (min-width:768px){' +
    '#cst-root #cookies-wrapper{padding:6px 24px!important;padding-bottom:calc(6px + env(safe-area-inset-bottom,0px))!important}' +
    '#cst-root .cookie-banner__actions{flex-shrink:0!important;flex-wrap:nowrap!important}' +
    '#cst-root button.ot-cookie{min-width:110px!important;padding:4px 16px!important}' +
    '}' +
    '@media (max-width:767px){' +
    '#cst-root #cookies-wrapper,#cst-root #cookies-wrapper.cst-position-full-bottom{' +
    'padding:6px 14px!important;' +
    'padding-bottom:calc(6px + env(safe-area-inset-bottom,0px))!important;' +
    'height:auto!important;max-height:none!important;min-height:0!important;' +
    'top:auto!important;bottom:0!important' +
    '}' +
    '#cst-root #ot-cookie-banner{height:auto!important;max-height:none!important}' +
    '#cst-root .cb__inner{display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:flex-start!important;gap:6px!important;height:auto!important;grid-template:none!important}' +
    '#cst-root .cb__text-block,#cst-root .cb__after-text,#cst-root .cookie-banner__actions{grid-area:auto!important}' +
    '#cst-root button.ot-cookie{min-height:36px!important}' +
    '#cst-root .cb__text-block,#cst-root .cb__after-text{flex:0 0 auto!important}' +
    '#cst-root .cookie-banner__actions{width:100%!important;justify-content:flex-start!important;flex:0 0 auto!important}' +
    '#cst-root #cookies-submit{flex:1 1 auto!important;min-width:120px!important}' +
    '}'

  function inject(root) {
    if (!root || root.getElementById(STYLE_ID)) return
    var style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = CSS
    root.appendChild(style)
  }

  function tryInject() {
    var host = document.getElementById('cst-shadow-host')
    if (host && host.shadowRoot) inject(host.shadowRoot)
  }

  tryInject()

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(tryInject).observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  }

  document.addEventListener('DOMContentLoaded', tryInject)
})()
